import { Account, PaymentTypes } from '@cashier/cashier-model';
import { AmountConverter } from '@cashier/cashier-shared';

export const InitialAmountProvider = {
  provide: (
    staticAmount: string | null,
    initialAmount: string | null,
    context: {
      account: Account;
      paymentType: PaymentTypes;
    },
  ): string | undefined => {
    if (staticAmount) {
      return AmountConverter.toSafeInteger(staticAmount);
    }

    if (initialAmount) {
      return AmountConverter.toSafeInteger(initialAmount);
    }

    const { paymentType, account } = context;

    if (paymentType === PaymentTypes.Withdrawal) {
      return undefined;
    }

    if (account && account.lastAmount !== '0.00') {
      return AmountConverter.toSafeInteger(account.lastAmount);
    }

    return undefined;
  },
};
